module.exports = __webpack_public_path__ + "img/qy_icon.1c27d3a.png";